import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	done: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tourHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tourBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchColumnPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchColumnPlaceholderNew: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingMessageStart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingMessageEnd: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	done: {
		id: 'issue-table-column-picker.column-picker.done',
		defaultMessage: 'Done',
		description: 'Done button in the spotlight tour card targeting the column switcher component',
	},
	tourHeading: {
		id: 'issue-table-column-picker.column-picker.tour-heading',
		defaultMessage: 'Column picker',
		description: 'Heading of the spotlight tour card targeting the column switcher component',
	},
	tourBody: {
		id: 'issue-table-column-picker.column-picker.tour-body',
		defaultMessage: 'Add or remove columns to see your most important fields.',
		description: 'Body of the spotlight tour card targeting the column switcher component',
	},
	searchColumnPlaceholder: {
		id: 'issue-table-column-picker.column-picker.search-column-placeholder',
		defaultMessage: 'Search column options',
		description: 'Placeholder for Column Picker search input',
	},
	searchColumnPlaceholderNew: {
		id: 'issue-table-column-picker.column-picker.search-column-placeholder-new',
		defaultMessage: 'Search columns',
		description: 'Placeholder for Column Picker search input',
	},
	loadingMessageStart: {
		id: 'issue-table-column-picker.column-picker.loading-message-start',
		defaultMessage: 'Loading more columns',
		description: 'Screen Reader text for loading more columns',
	},
	loadingMessageEnd: {
		id: 'issue-table-column-picker.column-picker.loading-message-end',
		defaultMessage: 'Finished loading columns',
		description: 'Screen Reader text for finishing of loading more columns',
	},
});

export default messages;
